import tokenizer, {Token} from 'airship/utils/tokenizer'
import {XDFForm, Header, privateHeaderKeys} from './reducer'
import {
  ExternalDataFeedObjectUnsaved,
  ExternalDataFeedObject,
  ResponseMapping,
} from 'airship/clients/xdf/types'

// parses urls like http://foo.com/[[bar]]
export const parseUrlUsingSquareBrackets = (url: string): Token[] =>
  tokenizer(url, /\[\[\s*(\w+)\s*\]\]/g)

export function buildCreatePayload(
  form: XDFForm
): ExternalDataFeedObjectUnsaved {
  const headers: {[key: string]: string} = {}
  form.headers.forEach((header) => {
    headers[header.key] = header.value
  })
  const defaultValues: {[key: string]: string} = {}
  form.defaultValues.forEach((defaultValue) => {
    defaultValues[defaultValue.key] = defaultValue.default
  })
  const responseMappings: ResponseMapping[] = form.responsePaths.map((rp) => {
    return {
      display_name: rp.name,
      original_path: rp.path,
    }
  })

  return {
    name: form.feedID,
    display_name: form.friendlyName,
    description: form.description,
    url: form.requestURL,
    headers: headers,
    default_values: defaultValues,
    response_mappings: responseMappings,
    request_cache_enabled: form.cacheResponse,
    throttle_rate: form.throttleRate.value,
  }
}

export function buildUpdatePayload(form: XDFForm): ExternalDataFeedObject {
  return {
    ...buildCreatePayload(form),
    id: form.meta.databaseID,
    created_on: form.meta.createdOn,
    updated_on: form.meta.updatedOn,
  }
}

export function headerIsPrivate(header: Header): boolean {
  return privateHeaderKeys.includes(header.key.trim().toLowerCase())
}

export function extractHostname(url: string): string {
  let hostname: string | undefined = url

  // find & remove protocol (http, ftp, etc.)
  if (url.indexOf('//') > -1) {
    hostname = url.split('//')[1]
  }

  // ignore everything after a "/:?#" character
  hostname = hostname?.split('/')[0]
  hostname = hostname?.split(':')[0]
  hostname = hostname?.split('?')[0]
  hostname = hostname?.split('#')[0]

  return hostname ?? ''
}
